import { Reducer } from "redux";

import AdminUserState from "./AdminUserState";
import { AdminUserAction, AdminUserTypes } from "./AdminUserActions";

const initialState: AdminUserState = {
  isSelectedUser: false,
  email: null
};

const AdminUserReducer: Reducer<AdminUserState, AdminUserAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case AdminUserTypes.SET_ADMIN_USER: {
      return {
        ...state,
        ...action.data
      };
    }
    default: {
      return state;
    }
  }
};

export default AdminUserReducer;